export default function Datenschutz() {
  return (
    <div id="RootRoot" className="flex w-full flex-col items-start justify-end space-y-4 [&_ul]:list-disc [&_ul]:pl-8">
      <h1>Datenschutzhinweis für den Dienst „CaboCHECK“</h1>

      <div>
        <h2>1. Name und Kontaktdaten des für die Verarbeitung Verantwortlichen sowie des Datenschutzbeauftragten</h2>
        <p>Diese Datenschutz-Information gilt für die Datenverarbeitung durch:</p>
        <p>
          Verantwortlicher: HEALYZER Health Analyzing Technologies GmbH, im Folgenden HAT genannt, Zimmerpforte 3, 20099
          Hamburg
        </p>
        <p>Email: datenschutz@healyzer.com</p>
        <p>Telefon: 040-33 46 87 80</p>
        <p>Telefax: 040-33 46 87 99</p>
        <p>
          Der Datenschutzbeauftragte der HAT ist unter der obigen Anschrift, beziehungsweise unter
          datenschutz@healyzer.com erreichbar.
        </p>
      </div>
      <div>
        <h2>2. Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung</h2>
        <p>
          Beim Erwerb eines Tests sowie zu dessen Durchführung und der Übermittlung der Testergebnisse verarbeiten wir
          die folgenden personenbezogenen Daten, die zum einen erforderlich sind, damit das medizinische Labor den Test
          durchführen kann, zum anderen um den Betroffenen über das Testergebnis per E-Mail informieren zu können:
        </p>
        <ul>
          <li>Name, Vorname</li>
          <li>Geburtsjahr</li>
          <li>Geschlecht</li>
        </ul>
        <p>Bei Analysen zu meldepflichtigen Befunden wird zudem die Adresse abgefragt.</p>
        <p>
          In Bezug auf bestimmte Testarten kann zur Beurteilung des Ergebnisses optional die Angabe weiterer Parameter
          erforderlich sein:
        </p>
        <ul>
          <li>Gewicht</li>
          <li>Größe</li>
          <li>Symptome wie z.B. das Vorliegen einer Schwangerschaft</li>
          <li>eingenommene Medikation</li>
          <li>Vorerkrankungen</li>
          <li>Postleitzahl</li>
        </ul>
        <p>Die Aufzählung der freiwilligen, optionalen Angaben ist beispielhaft und nicht abschließend.</p>
        <p>Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:</p>
        <ul>
          <li>Erwerb des Tests und dessen Durchführung</li>
          <li>Ermöglichung der Testdurchführung durch das medizinische Labor</li>
          <li>Information des Betroffenen über die Testergebnisse</li>
        </ul>
        <p>
          Rechtsgrundlage für die Datenverarbeitung ist die Durchführung eines Vertrages nach Art. 6 Abs. 1 lit. b DSGVO
          sowie Ihre Einwilligung nach Art. 9 Abs. 2 Buchst. a DSGVO.
        </p>
      </div>

      <h2>3. Weitergabe von Daten</h2>
      <p>
        Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet
        nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
      </p>
      <ul>
        <li>
          Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a oder Art. 9 Abs. 2 Buchst. a DSGVO ausdrückliche Einwilligung dazu
          erteilt haben,
        </li>
        <li>
          die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder Verteidigung von
          Rechtsansprüchen erforderlich ist und kein Grund zur Annahme besteht, dass Sie ein überwiegendes
          schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben,
        </li>
        <li>
          für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche Verpflichtung
          besteht, sowie
        </li>
        <li>
          dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von Vertragsverhältnissen
          mit Ihnen erforderlich ist.
        </li>
      </ul>
      <p>
        Wir geben die Daten an das medizinische Labor weiter, welches diese für die Durchführung des Tests benötigt.
      </p>

      <h2>4. Betroffenenrechte</h2>
      <p>Sie haben das Recht:</p>
      <ul>
        <li>
          gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen.
          Insbesondere können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der personenbezogenen Daten, die
          Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante
          Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder
          Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft ihrer Daten, sofern diese nicht bei uns erhoben
          wurden, sowie über das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling und ggf.
          aussagekräftigen Informationen zu deren Einzelheiten verlangen;
        </li>
        <li>
          gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns
          gespeicherten personenbezogenen Daten zu verlangen;
        </li>
        <li>
          gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen, soweit
          nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer
          rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder
          Verteidigung von Rechtsansprüchen erforderlich ist;
        </li>
        <li>
          gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, soweit die
          Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung
          ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder
          Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung
          eingelegt haben;
        </li>
        <li>
          gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten,
          gängigen und maschinenlesebaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu
          verlangen;
        </li>
        <li>
          gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen. Dies hat
          zur Folge, dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr
          fortführen dürfen und die Dienstleistung in diesem Fall nicht erbringen können und
        </li>
        <li>
          gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich hierfür an die
          Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes oder unseres Firmensitzes wenden.
        </li>
      </ul>

      <h2>5. Widerspruchsrecht</h2>
      <p>
        Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f
        DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung Ihrer
        personenbezogenen Daten einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen Situation
        ergeben oder sich der Widerspruch gegen Direktwerbung richtet. Im letzteren Fall haben Sie ein generelles
        Widerspruchsrecht, das ohne Angabe einer besonderen Situation von uns umgesetzt wird. Möchten Sie von Ihrem
        Widerrufs- oder Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an datenschutz@healyzer.com.
      </p>

      <h2>6. Datensicherheit</h2>
      <p>
        Wir ergreifen alle angemessenen technischen und organisatorischen Maßnahmen, um Ihre personenbezogenen Daten
        gegen Verlust, unberechtigten Zugriff, Veränderung und Verbreitung zu sichern. Bei der Kommunikation per E-Mail
        kann die vollständige Datensicherheit von uns nicht gewährleistet werden, so dass wir Ihnen bei vertraulichen
        Informationen den Postweg empfehlen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen
        Entwicklung fortlaufend verbessert.
      </p>

      <h2>7. Aktualität und Änderung dieser Datenschutzerklärung</h2>
      <p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Oktober 2023.</p>
    </div>
  );
}
